import Title from './Title'
import { Collapse } from 'antd'
import { Batch } from 'wujieai-react-icon'
import { useMemo, useState } from 'react'
import classNames from 'classnames'
import { CDNImage } from '~/components/business/CDNImage'
import { MyContainer } from '~/components/ui/MyContainer'

const items = [
  { key: '1', title: '软件', desc: '绘画软件&后台管理系统' },
  { key: '2', title: '算力', desc: '提供充足算力实现快速生成' },
  { key: '3', title: '模板', desc: '海量模板，灵活高效选配' },
  { key: '4', title: '服务', desc: '全程无忧，一键式操作使用' },
]
const tabs = [
  { value: 2, label: '企业版' },
  { value: 1, label: '个人版' },
]

function Solutions() {
  const [activeKey, setActiveKey] = useState<number>(2)
  const data = useMemo(() => {
    if (activeKey === 2) {
      return {
        serviceType: '商业版',
        desc: 'AI 绘画硬件机器设备提供商，可灵活配置不同设备和子商户的管理;\n生成效果支持快速打印，推荐使用设备：安卓设备硬件机器 + DNP-DSRX1',
        diagramUrl: '/images/mirror/business-diagram.png',
        funcPageUrl: '/images/mirror/business-example.jpg',
        systemUrl: '/images/mirror/business-back-example.jpg',
      }
    }
    return {
      serviceType: '个人版',
      desc: '个人线下利用AI影像软件创业者，可灵活配置不同的模板和绘画价格；\n生成效果支持快速打印，推荐使用设备：安卓设备（平板）+ DNP DS-RX1HS或HITI P525L',
      diagramUrl: '/images/mirror/personal-diagram.png',
      funcPageUrl: '/images/mirror/personal-example.jpg',
      systemUrl: '/images/mirror/personal-back-example.jpg',
    }
  }, [activeKey])
  return (
    <section className="w-full  bg-neutral-700 rounded-[3px]">
      <MyContainer className="!w-[1424px] !py-[64px] !px-[80px]">
        <Title text="我们帮您解决" desc="Solutions We Provide" />
        <div className="flex mt-6">
          {items.map(it => (
            <div
              key={it.key}
              className="w-1/4 bg-neutral-900 rounded-[16px] px-4 py-6 mr-4 last:mr-0"
            >
              <div className="flex flex-col items-center">
                <div className="flex items-center mb-2">
                  <div className="p-3 rounded-full bg-[#F6E9F6] border-[8px] border-neutral-900 mr-2">
                    <CDNImage src="/images/mirror/msg-chat-circle.svg" />
                  </div>
                  <div className="text-[24px] font-semibold text-neutral-200">
                    {it.title}
                  </div>
                </div>
                <div className="text-sm text-neutral-400">{it.desc}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-neutral-900 rounded-[16px] px-[48px] py-8 mt-6">
          <div className="flex justify-center">
            {tabs.map(item => (
              <div
                key={item.value}
                onClick={() => setActiveKey(item.value)}
                className={classNames(
                  'text-base text-neutral-500 py-2 px-6 font-semibolds rounded-[48px] cursor-pointer mr-6 last:mr-0',
                  {
                    ['!text-neutral-900']: item.value === activeKey,
                  }
                )}
                style={{
                  background:
                    activeKey === item.value
                      ? 'linear-gradient(321deg, #6964DE -10.33%, #FCA6E9 100%)'
                      : '#F4F5F6',
                }}
              >
                {item.label}
              </div>
            ))}
          </div>
          <div className="my-6 text-base text-neutral-400 font-semibold text-center whitespace-pre">
            {data.desc}
          </div>
          <div className="flex">
            <div className="w-[632px]">
              <CDNImage className="w-full" src={data.diagramUrl} />
              <div className="flex items-center justify-center mt-3">
                <CDNImage src="/images/mirror/triangle-icon.svg" />
                <div className="text-xs text-neutral-500 font-semibold ml-2">
                  {data.serviceType}开通步骤
                </div>
              </div>
            </div>
            <div className="flex-1 ml-6">
              <div className="mb-4">
                <div
                  className="w-full h-[306px] rounded-[24px] border border-solid"
                  style={{ borderColor: 'rgba(0, 0, 0, 0.08)' }}
                >
                  <CDNImage
                    className="w-full h-full rounded-[24px]"
                    src={data.funcPageUrl}
                  />
                </div>
                <div className="flex items-center justify-center mt-3">
                  <CDNImage src="/images/mirror/triangle-icon.svg" />
                  <div className="text-xs text-neutral-500 font-semibold ml-2">
                    {data.serviceType}软件功能主页面
                  </div>
                </div>
              </div>
              <div>
                <div
                  className="w-full h-[306px] rounded-[24px] border border-solid"
                  style={{ borderColor: 'rgba(0, 0, 0, 0.08)' }}
                >
                  <CDNImage
                    className="w-full h-full rounded-[24px]"
                    src={data.systemUrl}
                  />
                </div>
                <div className="flex items-center justify-center mt-3">
                  <CDNImage src="/images/mirror/triangle-icon.svg" />
                  <div className="text-xs text-neutral-500 font-semibold ml-2">
                    {data.serviceType}运营管理系统
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MyContainer>
    </section>
  )
}

export default Solutions
